import { supertypeClass } from '@haventech/amorphic';
import { ClientCustomerProps } from '../../js/interfaces/CoverpathTypes';
import { Product } from '../../../common/js/static/Product';
import { MMDirectCustomer } from '../mmdirect_subclasses/MMDirectCustomer';
import { LifeBridgePolicy } from './LifeBridgePolicy';

@supertypeClass({ toClient: true, toServer: true })
export class LifeBridgeCustomer extends MMDirectCustomer {
  constructor() {
    super();
  }

  static new(quoteType?: string) {
    if (quoteType) {
      const customer = new LifeBridgeCustomer().init();
      customer.initializeQuote(quoteType);
      return customer;
    } else {
      return new LifeBridgeCustomer().init();
    }
  }

  init() {
    super.init();
    this.channel = Product.channels.LifeBridge.code;

    return this;
  }

  static create(props: ClientCustomerProps) {
    const setPolicyProps = () => {
      customer.application.primaryPolicy.product = Product.products.ET10.code;
      return customer;
    };

    const customer = LifeBridgeCustomer.new(props.quoteType);
    customer.reset();
    customer.updateProps(props);

    return customer.createPolicy(Product.products.ET10.quoteKey.quoteKey).then(setPolicyProps);
  }

  newPolicy() {
    const policy = LifeBridgePolicy.new(this);

    policy.waiver = null;

    return policy;
  }
}
